export function FullPageSpinner() {
  return (
    <div className='flex min-h-dvh items-center justify-center'>
      <div className='size-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
    </div>
  )
}
